import React, { FunctionComponent } from 'react'
import { Grid, Text } from '@afterpaytouch/core'
import { Money } from '../../../../../component'
import type { Money as MoneyValue } from '@afterpay/types'
import { useTranslation, Trans } from '../../../../../utils/convergence'

interface FinancingSummaryProps {
  apr?: string
  interestAmount?: MoneyValue
  monthlyAmount?: MoneyValue
  numberOfInstallments?: number
  hasInterestAmount: boolean
  isPayInFull?: boolean
}

export const FinancingSummary: FunctionComponent<FinancingSummaryProps> = ({
  apr,
  interestAmount,
  monthlyAmount,
  numberOfInstallments,
  hasInterestAmount,
  isPayInFull,
}) => {
  const { t } = useTranslation(['summary'])

  if (isPayInFull) {
    return (
      <Grid>
        <Text color='Gray50' renderAs='div'>
          {t('appleRetail.payInFullToday')}
        </Text>
      </Grid>
    )
  }

  return (
    <Grid>
      <Text color='Gray50' renderAs='div'>
        <div>
          <span>{t('appleRetail.interestRate', { apr })}</span>
          {hasInterestAmount && (
            <span>
              <Trans
                i18nKey='summary:appleRetail.interestTotal'
                components={{
                  money: <Money color='IGNORE' value={interestAmount} />,
                }}
              />
            </span>
          )}
        </div>
        <div>
          <span>
            <Trans
              i18nKey='summary:appleRetail.monthly'
              components={{
                money: <Money color='IGNORE' value={monthlyAmount} />,
              }}
            />
          </span>{' '}
          <span>{t('appleRetail.monthPlan', { months: numberOfInstallments })}</span>
        </div>
      </Text>
    </Grid>
  )
}
